import React from 'react';
import Routes from './routes/Routes';

const App = ({ isOfficeInitialized }) => isOfficeInitialized && <Routes />;

export default App;
